import { Box, Popover, Tooltip, ButtonBase } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { get } from "lodash";
import useStyles from "./styles";
import ReactWordcloud from "react-wordcloud";
import { useLazyQuery, useMutation } from "@apollo/client";
import { getWordCloud } from "../../../graphQL/queries/visionBoard";
import { visionWordsAndCommentsMutation } from "../../../graphQL/mutation/visionBoardMutations";
import { Auth } from "aws-amplify";
import LoadingWidget from "../../widgets/LoadingWidget";
import "d3-transition";
import { select } from "d3-selection";
import { useTranslation } from "react-i18next";
import { getUserId } from "../../../utils";
import { VISION_ENCORAGEMENT_WORD } from "../../../constants/literalConstant";
// import useToastMessage from "../../../hooks/useToastMessage";
// import { TOAST_MESSAGE } from "../../../constants";
// import ToastMessage from "../../widgets/ToastMessage";
import ClapIcon from "Assets/images/clapping.svg";
import { loggedInUserState } from "Recoil/LoggedInUserDetail/atom";
import { useRecoilValue } from "recoil";
import { useToast } from "Hooks/useToast";

const WordCloudPopover = ({
  visionDetail,
  visionId,
  setDisplayVision,
  setMyVision,
  listVision,
  updateNotification,
  notification,
  noDetails,
  setCountLoader,
  // isFromDashboard,
  // toastMessageForDashboard,
  isFromBanner
}) => {
  const classes = useStyles();
  const toaster = useToast();
  // const { toastMessage, resetState, toastMessageDisplay } = useToastMessage();
  const { t } = useTranslation();
  const companyId = get(Auth, "user.attributes.custom:companyId", "");
  const [anchorEl, setAnchorEl] = useState(null);
  const [words, setWords] = useState([]);
  const user = useRecoilValue(loggedInUserState);
  const [addEncouragement] = useMutation(visionWordsAndCommentsMutation);
  const [getWordsQuery, { loading: getWordLoading }] = useLazyQuery(
    getWordCloud,
    {
      // nextFetchPolicy: FETCH_POLICY.cacheOnly,
      onCompleted: data => {
        const wordCloudData = get(data, "getCompany.wordCloud", []);
        const wordsDisplay = wordCloudData.map(res => {
          return {
            text: res.word,
            value: res.count
          };
        });
        setWords(wordsDisplay);
      }
    }
  );
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const getWordCloudData = () => {
    const variables = {
      id: companyId
    };
    getWordsQuery({
      variables
    });
  };
  useEffect(() => {
    getWordCloudData();
  }, []);

  const addEncouragementToVision = word => {
    handleClose();
    setCountLoader && setCountLoader(true);
    const variables = {
      input: {
        visionId,
        responseType: "EncouragementWord",
        createdByUserId: userId,
        encouragementWord: get(word, "text", "")
      }
    };
    addEncouragement({ variables }).then(res => {
      if (get(res, "data.visionWordsAndCommentsMutation.isWordExist", false)) {
        toaster.error({ message: "Word already exist" });
        // if (isFromDashboard) {
        //   toastMessageForDashboard("Word already exist", TOAST_MESSAGE.ERROR)
        // } else {
        //   toastMessageDisplay("Word already exist", TOAST_MESSAGE.ERROR)
        // }
        setCountLoader && setCountLoader(false);
        return;
      }
      if (updateNotification) {
        updateNotification(notification);
      }
      if (setMyVision && setDisplayVision) {
        const newEncouragement = get(
          res,
          "data.visionWordsAndCommentsMutation",
          {}
        );
        const profileImage = user.profileImage || {};
        newEncouragement.createdBy = {
          firstName: user.firstName,
          lastName: user.lastName,
          profileImage
        };
        const encourageData =
          get(visionDetail, VISION_ENCORAGEMENT_WORD, []) || [];
        const value = [...encourageData, newEncouragement];
        const currentVision = {
          ...visionDetail,
          encouragementWords: { items: value }
        };
        setDisplayVision(currentVision);
        const visions = (listVision || []).map(result => {
          if (visionId === result.id) {
            return currentVision;
          }
          return result;
        });
        setMyVision(visions);
      }
      setCountLoader && setCountLoader(false);
    });
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const userId = getUserId();
  const containerRef = useRef();
  const getCallback = callback => {
    return function (word, event) {
      const isActive = callback !== "onWordMouseOut";
      const element = event.target;
      const text = select(element);
      text
        .on("click", async () => {
          if (isActive) {
            await addEncouragementToVision(word);
          }
        })
        // .transition()
        .attr("background", "white")
        .attr("font-size", isActive ? "16px" : "12px")
        .attr("text-decoration", isActive ? "underline" : "none")
        
    };
  };
  const callbacks = {
    getWordColor: () => "#fff", //(word.value > 50 ? "#fff" : "#fff"),
    // getWordTooltip: word =>
    //   `The word "${word.text}" appears ${word.value} times.`,
    onWordClick: getCallback("onWordClick"),
    onWordMouseOut: getCallback("onWordMouseOut"),
    onWordMouseOver: getCallback("onWordMouseOver")
  };

  const options = {
    deterministic: false,
    enableTooltip: false,
    fontFamily: "Poppins",
    fontSizes: [14, 18],
    padding: 5,
    rotations: 3,
    rotationAngles: [0, 0],
    scale: "sqrt",
    spiral: "archimedean",
    transitionDuration: 500
  };

  return (
    <Box className={classes.visionLikePopover}>
      <Tooltip title={t("visionBoard.encouragementWords")}>
        <ButtonBase
          data-testid="btn"
          onClick={handleClick}
          disabled={noDetails}>
          <img
            src={ClapIcon}
            alt="icon"
            className={isFromBanner ? classes.clapIcon : ""}
          />
        </ButtonBase>
      </Tooltip>
      {/* //{get(visionDetail, "enableComments", false) ? ( */}
      <Popover
        container={get(containerRef, "current", "")}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
        className={classes.blackBg}>
        {getWordLoading ? (
          <div style={{ textAlign: "center", padding: "5rem" }}>
            <LoadingWidget color="grey" />
          </div>
        ) : (
          <Box className={classes.wordCloud}>
            <ReactWordcloud
              words={words}
              callbacks={callbacks}
              options={options}
            />
          </Box>
        )}
      </Popover>
      {/* ) : null} */}
      {/* {toastMessage.display && !isFromDashboard && (
        <ToastMessage
          toastMessage={toastMessage}
          setToastMessage={resetState}
        />
      )} */}
    </Box>
  );
};

export default WordCloudPopover;
